"use client";
import {
  useClientShorts,
  useClientThumbnails,
  useClientVideos,
  useClientInformation,
  useClientAggregate,
  useClientMeta,
} from "@std/@/kooleyy/hooks/client";
import Image from "next/image";
import { SideBoxes } from "./Header";

export const NothingHere = ({ id }) => {
  const [client, clientPending] = useClientMeta({ id });

  if (clientPending) return null;

  if (
    client?.totals?.videos !== 0 &&
    client?.totals?.thumbnails !== 0 &&
    client?.totals?.shorts !== 0
  )
    return null;

  return (
    <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
      <Image
        width="128"
        height="128"
        referrerPolicy="no-referrer"
        className="w-32 h-32 opacity-50"
        alt={"Cookie Munch"}
        src={"/cookieEat.gif"}
      />
      <h1 className="text-xl font-BreezeHeader text-center text-gray-300">
        We couldn&apos;t find anything here.
      </h1>
    </div>
  );
};

export const ClientSideBoxes = ({ id }) => {
  const [client, clientPending] = useClientInformation({ id });
  const [videos, videosPending] = useClientVideos({ id });
  const [thumbnails, thumbnailsPending] = useClientThumbnails({
    id,
  });
  const [shorts, shortsPending] = useClientShorts({ id });
  const [clientAggregate, clientAggregatePending] = useClientAggregate({ id });

  if (
    clientPending ||
    videosPending ||
    thumbnailsPending ||
    shortsPending ||
    clientAggregatePending
  )
    return (
      <div className="flex flex-col items-center xl:items-end w-full xl:max-w-[17.5vw] xl:ml-10 mt-2">
        <div className="flex flex-col gap-y-4 w-full">
          <div className="rounded-2xl bg-gray-500 animate-pulse h-64 w-full" />
          <div className="rounded-2xl bg-gray-500 animate-pulse h-32 w-full" />
          <div className="rounded-2xl bg-gray-500 animate-pulse h-36 w-full" />
        </div>
      </div>
    );

  return (
    <div className="flex flex-col items-center xl:items-end w-full xl:max-w-[17.5vw] xl:ml-10">
      <SideBoxes
        id={id}
        name={client?.name}
        subscribers={client?.channelSocial?.subscribers}
        avatar={client?.thumbnail?.high?.url}
        videos={parseInt(videos?.total?.value || 0)}
        shorts={parseInt(shorts?.total?.value || 0)}
        thumbnails={parseInt(thumbnails?.total?.value || 0)}
        views={parseInt(clientAggregate?.views || 0)}
        description={client?.description}
      />
    </div>
  );
};
